/**
 * 送货单列表接口，包括订单详情、订单编辑、提交签收单等
 * @author yangyu
 */
export default {
  BASE_URL: '',
  api: [
    {
      name: 'list',
      desc: '送货单列表',
      method: 'GET',
      path: '/tm/order/receipt/list'
    },
    {
      name: 'exportDetailExcel',
      desc: '销售送货单导出',
      method: 'POST',
      path: '/tm/order/receipt/exportDetailExcel'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/order/receiptOrder.js